import React from 'react'
import * as Styles from './icon.styles'
import InsertDriveFileOutlinedIcon from '@material-ui/icons/InsertDriveFileOutlined'
import InsertChartOutlinedIcon from '@material-ui/icons/InsertChartOutlined'
import PermIdentityOutlinedIcon from '@material-ui/icons/PermIdentityOutlined'
import ChevronLeftOutlinedIcon from '@material-ui/icons/ChevronLeftOutlined'
import ChevronRightOutlinedIcon from '@material-ui/icons/ChevronRightOutlined'
import KeyboardArrowUpOutlinedIcon from '@material-ui/icons/KeyboardArrowUpOutlined'
import KeyboardArrowDownOutlinedIcon from '@material-ui/icons/KeyboardArrowDownOutlined'
import AddOutlinedIcon from '@material-ui/icons/AddOutlined'
import FilterListOutlinedIcon from '@material-ui/icons/FilterListOutlined'
import GetAppIcon from '@material-ui/icons/GetApp'
import SettingsOutlinedIcon from '@material-ui/icons/SettingsOutlined'
import AutorenewIcon from '@material-ui/icons/Autorenew'
import CheckIcon from '@material-ui/icons/Check'
import ErrorOutlineOutlinedIcon from '@material-ui/icons/ErrorOutlineOutlined'
import ArrowUpwardOutlinedIcon from '@material-ui/icons/ArrowUpwardOutlined'
import NotificationsNoneOutlinedIcon from '@material-ui/icons/NotificationsNoneOutlined'
import CloseOutlinedIcon from '@material-ui/icons/CloseOutlined'
import CalendarTodayOutlinedIcon from '@material-ui/icons/CalendarTodayOutlined'

type Props = {
  icon: any
}

const Icon: React.FC<any> = (props: Props) => {
  let icon = null
  switch (props.icon) {
    case 'file':
      icon = <InsertDriveFileOutlinedIcon></InsertDriveFileOutlinedIcon>
      break
    case 'chart':
      icon = <InsertChartOutlinedIcon></InsertChartOutlinedIcon>
      break
    case 'identity':
      icon = <PermIdentityOutlinedIcon></PermIdentityOutlinedIcon>
      break
    case 'chevron-left':
      icon = <ChevronLeftOutlinedIcon></ChevronLeftOutlinedIcon>
      break
    case 'chevron-right':
      icon = <ChevronRightOutlinedIcon></ChevronRightOutlinedIcon>
      break
    case 'chevron-up':
      icon = <KeyboardArrowUpOutlinedIcon></KeyboardArrowUpOutlinedIcon>
      break
    case 'chevron-down':
      icon = <KeyboardArrowDownOutlinedIcon></KeyboardArrowDownOutlinedIcon>
      break
    case 'close':
      icon = <CloseOutlinedIcon></CloseOutlinedIcon>
      break
    case 'filter-list':
      icon = <FilterListOutlinedIcon></FilterListOutlinedIcon>
      break
    case 'get-app':
      icon = <GetAppIcon></GetAppIcon>
      break
    case 'setting':
      icon = <SettingsOutlinedIcon></SettingsOutlinedIcon>
      break
    case 'autorenew':
      icon = <AutorenewIcon></AutorenewIcon>
      break
    case 'check':
      icon = <CheckIcon></CheckIcon>
      break
    case 'error':
      icon = <ErrorOutlineOutlinedIcon></ErrorOutlineOutlinedIcon>
      break
    case 'arrow-upward':
      icon = <ArrowUpwardOutlinedIcon></ArrowUpwardOutlinedIcon>
      break
    case 'arrow-downward':
      icon = <KeyboardArrowDownOutlinedIcon></KeyboardArrowDownOutlinedIcon>
      break
    case 'notifications':
      icon = <NotificationsNoneOutlinedIcon></NotificationsNoneOutlinedIcon>
      break
    case 'add':
      icon = <AddOutlinedIcon></AddOutlinedIcon>
      break
    case 'calendar-today':
      icon = <CalendarTodayOutlinedIcon></CalendarTodayOutlinedIcon>
      break
  }
  return (
    <Styles.Icon>
      {icon}
    </Styles.Icon>
  )
}

export default Icon
